import { handleClassNames } from "lib/cssHelpers";
import React, { useEffect } from "react";
import Style from "@assets/css/home.module.css";
import LazyLoad from "react-lazyload";
import ReadMoreReact from "read-more-react/dist/components/ReadMoreReact";
import { useState } from "react";
import { isMobile } from "react-device-detect";
import { useRouter } from "next/dist/client/router";
import Reviews from "./review.json";
import Slider from "react-slick";
import Skeleton from "react-loading-skeleton";
const ReviewSection = () => {
  const [ReviewData, setReviewData] = useState([]);
  const router = useRouter();
  const handleClasses = (classValue) => {
    return handleClassNames(classValue, Style);
  };

  useEffect(() => {
    const CurrentPage =
      router?.query && router?.query?.slug && router?.query?.slug?.length
        ? router?.query?.slug[1]
        : "";
    let category = "";
    if (typeof localStorage !== "undefined") {
      category = localStorage.getItem("selected-service");
    }
    Reviews.reviews.map((item) => {
      if (item.page == category || item.page == CurrentPage) {
        setReviewData(item.content);
      }
    });
  }, [router]);

  const [swiper, setSwiper] = useState(null);

  const settings = {
    arrows: false,
    dots: false,
    speed: 500,
    slidesToShow: isMobile ? 1 : 2,
    slidesToScroll: 1,
    pauseOnHover: false,
  };

  return (
    <section className={handleClasses("review-section service-cm-faqs")}>
      <div className="container">
        <img
          className={handleClasses("google-icon")}
          src="/assets/home/google.webp"
          alt="google"
        />
        <div className="row">
          <div className="col-lg-12">
            <div className="text-center title-anim">
              <div className={handleClasses("header-all")}>
                Customer Reviews
              </div>
            </div>
            <div className="text-center">
              <div className={handleClasses("rating-blk")}>
                <span className="text-secondary">Rating: 4.4</span>
                <div
                  className={`star-skn-block ${handleClasses(
                    "star-skn-block"
                  )}`}
                >
                  <div className={handleClasses("stars")}>
                    <svg viewBox="0 0 576 512" width={100} title="star">
                      <path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z" />
                    </svg>
                    <svg viewBox="0 0 576 512" width={100} title="star">
                      <path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z" />
                    </svg>
                    <svg viewBox="0 0 576 512" width={100} title="star">
                      <path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z" />
                    </svg>
                    <svg viewBox="0 0 576 512" width={100} title="star">
                      <path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z" />
                    </svg>
                    <svg viewBox="0 0 576 512" width={100} title="star">
                      <path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z" />
                    </svg>
                    <div
                      className={handleClasses("cover")}
                      style={{ width: "10%" }}
                    />
                  </div>
                </div>
                <a
                  target="_blank"
                  href="https://g.page/r/CQ-cn6YSSqO2EB0/review"
                  className={handleClasses("purple")}
                >
                  Google Reviews
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className={handleClasses("rev-slider-skin")}>
          <div className={handleClasses("rev-slider-container")}>
            <Slider {...settings} getSwiper={setSwiper}>
              {ReviewData.length
                ? ReviewData?.map((e, index) => (
                    <LazyLoad key={index}>
                      <div
                        className={`d-flex justify-content-center align-items-center flex-column mt-5 ${handleClasses(
                          "google-head"
                        )}`}
                      >
                        <div className={handleClasses("google-card")}>
                          <div className={handleClasses("google-container")}>
                            <div className="pl-3">
                              <div className={handleClasses("google-text")}>
                                <div className="display-text-group">
                                  <span
                                    className={handleClasses("displayed-text")}
                                  >
                                    <ReadMoreReact
                                      text={e?.review}
                                      min={80}
                                      readMoreText={
                                        <a className="text-primary">
                                          Read More
                                        </a>
                                      }
                                    />
                                    {/* I was skeptical at first but since they are partnered
                                                                with Amazon it gave me a bit of confidence to avail
                                                                services from Open Bonnet.
                                                                <span className={handleClasses("hide")}>
                                                                    They will assist you with the process and are highly
                                                                    attentive to your queries and concerns. They help
                                                                    their customers understand the sequences and does
                                                                    the job nicely with real-time support. Highly
                                                                    recommended car service and most specially available
                                                                    through Amazon.
                                                                </span>
                                                                <div className={handleClasses("read-more-button")}>
                                                                    <a className="text-primary">Read More</a>
                                                                </div> */}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="d-flex justify-content-start pl-3">
                              <div className={handleClasses("profile")}>
                                <div className={handleClasses("pro-image")}>
                                  <img
                                    src={e?.img}
                                    alt="Google"
                                    decoding="async"
                                    data-nimg="fill"
                                  />
                                </div>
                              </div>
                              <p
                                className={`p-2 ${handleClasses(
                                  "google-text pro-info"
                                )}`}
                              >
                                {" "}
                                {e.name}, <br />
                                <span
                                  className={handleClasses("pro-info-span")}
                                >
                                  {e.car}, {e.location}
                                </span>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </LazyLoad>
                  ))
                : [null, null]?.map((e, index) => (
                    <LazyLoad key={index}>
                      <div
                        className={`d-flex justify-content-center align-items-center flex-column mt-5 ${handleClasses(
                          "google-head"
                        )}`}
                      >
                        <div className={handleClasses("google-card")}>
                          <div className={handleClasses("google-container")}>
                            <div className="pl-3">
                              <div className={handleClasses("google-text")}>
                                <div className="display-text-group">
                                  <span
                                    className={handleClasses("displayed-text")}
                                  >
                                    <Skeleton height={50} />
                                    <Skeleton height={50} />
                                    <Skeleton height={50} />
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="d-flex justify-content-start pl-3">
                              <div className={handleClasses("profile")}>
                                <div className={handleClasses("pro-image")}>
                                  <img
                                    src={"/assets/header/user-dummy.webp"}
                                    alt="Google"
                                    decoding="async"
                                    data-nimg="fill"
                                  />
                                </div>
                              </div>
                              <p
                                className={`p-2 ${handleClasses(
                                  "google-text pro-info"
                                )}`}
                              >
                                {" "}
                                {"fetching...."} <br />
                                <span
                                  className={handleClasses("pro-info-span")}
                                >
                                  <Skeleton />
                                </span>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </LazyLoad>
                  ))}
            </Slider>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ReviewSection;
